// コメントの最大長（UTF-8バイト数）
export const MAX_COMMENT_LENGTH = 6000;

/**
 * 文字列のUTF-8バイト数を数える
 */
export const utf8ByteLength = (str) => new TextEncoder().encode(str).length;

/**
 * UTF-8の合計バイト数がmaxBytesを超えないように文字列を切り詰める
 */
export const truncateUtf8 = (str, maxBytes) => {
    const encoder = new TextEncoder();
    const decoder = new TextDecoder("utf-8", { fatal: false });

    let bytes = encoder.encode(str);
    if (bytes.length <= maxBytes) return str;

    // 一旦切り取ってデコード、失敗した場合は少しずつ戻していく
    let cut = bytes.slice(0, maxBytes);
    while (cut.length > 0) {
        const decoded = decoder.decode(cut);
        if (encoder.encode(decoded).length <= maxBytes) return decoded;
        cut = cut.slice(0, -1);
    }
    return "";
};
